import { render } from "./DropList.vue?vue&type=template&id=2453c15c"
import script from "./DropList.vue?vue&type=script&lang=js"
export * from "./DropList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__

/* vue-cli-plugin-import-components */

import DropTable from "@/components/neue/DropTable.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import NeueWell from "@/components/neue/NeueWell.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
script.components = Object.assign({}, { DropTable, NeueButton, NeueWell, SecondaryNav, SecondaryTop }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { DropTable, NeueButton, NeueWell, SecondaryNav, SecondaryTop }, script.__o.components);}